var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0329 5.6267C24.958 3.40369 21.8615 1.58487 18.2596 2.64383C16.5384 3.14481 15.0368 4.21916 13.9999 5.69137C12.963 4.21916 11.4614 3.14481 9.74021 2.64383C6.13031 1.60104 3.04183 3.40369 1.96688 5.6267C0.458746 8.73892 1.08446 12.2391 3.82799 16.0304C5.97789 18.9971 9.05032 22.0042 13.5106 25.4964C13.6515 25.6072 13.8252 25.6673 14.0039 25.6673C14.1827 25.6673 14.3563 25.6072 14.4973 25.4964C18.9495 22.0123 22.0299 19.0294 24.1798 16.0304C26.9153 12.2391 27.5411 8.73892 26.0329 5.6267Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRed);
export default __webpack_public_path__ + "static/media/heart-red.78c598c17f2fdb5c0c6009463ecc3675.svg";
export { ForwardRef as ReactComponent };